import { Tooltip } from 'antd';
import { ComponentType } from 'react';
import { styled } from 'styled-components';

export const StyledTooltip = styled(Tooltip as ComponentType<any>)`
    .ant-tooltip-content {
        .ant-tooltip-inner {
            background-color: var(--color-neutral);
            color: var(--color-on-neutral);
            border-radius: 4px;
            padding: 8px 12px;
            font-size: 1rem;
        }
    }
`;

export const StyledIconWrapper = styled.span`
    color: var(--color-neutral);
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    justify-content: center;

    &:hover {
        color: var(--color-neutral);
    }
`;
